import { HexColor } from '@repo/shared/types';
import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityBasicText } from './basicText';
import { form, SanityForm } from './form';
import { formConfirmation, SanityFormConfirmation } from './formConfirmation';
import { image, SanityImage } from './image';
import { logoWall, SanityLogoWall } from './logoWall';
import { richText } from './richText';
import { SanityVideoLoop, videoLoop } from './videoLoop';

export const SanityTwoUpForm = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('twoUpForm'),
  _key: z.string(),
  theme: z.enum(['light', 'dark', 'charcoal', 'purple']),
  overline: z.string().optional().nullable(),
  headline: z.string(),
  headlineSize: z.enum(['normal', 'large']),
  desktopFormPosition: z.enum(['left', 'right']),
  display: z.enum(['default', 'headingAbove']),
  bodyCopy: z.string().optional().nullable(),
  formattedBodyCopy: SanityBasicText.optional().nullable(),
  additionalContent: z
    .array(z.union([SanityImage, SanityVideoLoop, SanityLogoWall]))
    .optional()
    .nullable(),
  form: SanityForm, // TODO: nullable?
  confirmation: SanityFormConfirmation,
  background: HexColor.optional().nullable(),
});
export type SanityTwoUpForm = z.infer<typeof SanityTwoUpForm>;

export const twoUpForm = groq`{
  "theme": select(theme == "dark" => "charcoal", coalesce(theme, "light")),
  overline,
  headline,
  headlineSize,
  bodyCopy,
  "display": coalesce(display, "default"),
 formattedBodyCopy[] ${richText},
  additionalContent[] {
    _key,
    _type,
    _type == 'image' => ${image},
    _type == 'videoLoop' => ${videoLoop},
    _type == 'logoWall' => ${logoWall},
  },
  "desktopFormPosition": coalesce(desktopFormPosition, "right"),
  form-> ${form},
  confirmation ${formConfirmation},
  'background': background->color.hex,
}`;
